document.addEventListener('DOMContentLoaded', () => {
    // 1. Scroll Logic (Hide on down, Show on up)
    const header = document.querySelector('.aksion-header');
    let lastScroll = 0;
    const scrollThreshold = 100; // Only start hiding after scrolling down 100px

    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        // Validation to prevent negative scroll (bounce effect on iOS)
        if (currentScroll <= 0) {
            header.classList.remove('nav-hidden');
            return;
        }

        // Logic: If scrolling down AND passed threshold -> Hide
        if (currentScroll > lastScroll && currentScroll > scrollThreshold && !header.classList.contains('nav-hidden')) {
            header.classList.add('nav-hidden');
        } 
        // Logic: If scrolling up -> Show
        else if (currentScroll < lastScroll && header.classList.contains('nav-hidden')) {
            header.classList.remove('nav-hidden');
        }

        lastScroll = currentScroll;
    });

    // 2. Mobile Menu Logic
    const toggleBtn = document.querySelector('.aksion-header__toggle');
    const mobileMenu = document.querySelector('.aksion-mobile-menu');
    const overlay = document.querySelector('.aksion-mobile-menu__overlay');

    if (toggleBtn && mobileMenu) {
        const toggleMenu = () => {
            const isOpen = mobileMenu.classList.contains('is-open');
            
            if (isOpen) {
                mobileMenu.classList.remove('is-open');
                toggleBtn.classList.remove('is-active');
                document.body.style.overflow = ''; // Restore scroll
            } else {
                mobileMenu.classList.add('is-open');
                toggleBtn.classList.add('is-active');
                document.body.style.overflow = 'hidden'; // Lock body scroll
            }
        };

        toggleBtn.addEventListener('click', toggleMenu);
        overlay.addEventListener('click', toggleMenu); // Click background to close
    }

    // ==========================================
    // 2.5 CLONE DESKTOP BUTTONS TO MOBILE DRAWER
    // ==========================================
    // Since InnerBlocks only renders once in the DOM, we clone the outputted buttons into the mobile menu.
    const desktopButtons = document.querySelector('.aksion-header__buttons');
    const mobileDrawerContent = document.querySelector('.aksion-mobile-menu__content');

    if (desktopButtons && mobileDrawerContent && desktopButtons.innerHTML.trim() !== '') {
        const mobileButtonsContainer = document.createElement('div');
        mobileButtonsContainer.className = 'aksion-mobile-buttons';
        
        // Copy the inner HTML (the WordPress button blocks)
        mobileButtonsContainer.innerHTML = desktopButtons.innerHTML;
        
        // Append them to the bottom of the mobile drawer content
        mobileDrawerContent.appendChild(mobileButtonsContainer);
    }
    // ==========================================

    // 3. Mobile Accordion for Submenus
    const submenuToggles = document.querySelectorAll('.submenu-toggle');
    submenuToggles.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const submenu = btn.parentElement.nextElementSibling;
            
            if (submenu) {
                const isHidden = submenu.style.display === 'none';
                submenu.style.display = isHidden ? 'block' : 'none';
                btn.style.transform = isHidden ? 'rotate(180deg)' : 'rotate(0deg)';
            }
        });
    });


    // 4. Search Ajax Logic
    
    // --- SELECTORS ---
    const triggerBtn = document.getElementById('search-trigger');
    const closeBtn = document.getElementById('search-close');
    const searchOverlay = document.getElementById('search-overlay'); // Renamed variable
    const input = document.getElementById('search-term');
    const resultsDiv = document.getElementById('search-results');
    const spinner = document.getElementById('search-spinner');
    const seeAllBtn = document.getElementById('search-see-all');
    
    let typingTimer;
    
    // --- 1. OVERLAY TELEPORT & TOGGLE ---
    
    if (searchOverlay) {
        // Move overlay to bottom of <body> to escape sticky headers/overflows
        document.body.appendChild(searchOverlay);
    }

    // Open Overlay
    if (triggerBtn) {
        triggerBtn.addEventListener('click', (e) => {
            e.preventDefault();
            searchOverlay.classList.add('active');
            document.body.style.overflow = 'hidden'; // Lock Scroll
            
            // Auto focus input
            setTimeout(() => input.focus(), 100);
        });
    }

    // Close Overlay Helper
    const closeOverlay = () => {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = ''; // Unlock Scroll
    };

    // Close Button Event
    if (closeBtn) {
        closeBtn.addEventListener('click', closeOverlay);
    }
    
    // Close on Escape Key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
            closeOverlay();
        }
    });

    // --- 2. SEARCH LOGIC ---

    if (input) {
        input.addEventListener('keyup', (e) => {
            const searchTerm = e.target.value.trim();

            // Clear previous timer
            clearTimeout(typingTimer);

            // Hide/Show "See All" button & Clear if empty
            if (searchTerm) {
                
                // Show the "See All" button
                if (seeAllBtn) {
                    seeAllBtn.style.display = "inline-block";
                    // Update href dynamically
                    const baseUrl = (typeof mySearchData !== 'undefined') ? mySearchData.home_url : '/';
                    seeAllBtn.href = `${baseUrl}?s=${encodeURIComponent(searchTerm)}`;
                }

            } else {
                if (seeAllBtn) seeAllBtn.style.display = "none";
                resultsDiv.innerHTML = "";
                spinner.style.display = "none";
                return; // Stop if empty
            }

            // Show Spinner
            spinner.style.display = "block";

            // Debounce (Wait 500ms)
            typingTimer = setTimeout(() => {
                performSearch(searchTerm);
            }, 500);
        });
    }

    function performSearch(term) {
        // Prepare Data
        const formData = new URLSearchParams();
        formData.append('action', 'my_search_action');
        formData.append('term', term);
        
        // Ensure nonce is localized in PHP
        if (typeof mySearchData !== 'undefined') {
            formData.append('security', mySearchData.nonce);
        }

        const ajaxUrl = (typeof mySearchData !== 'undefined') ? mySearchData.ajax_url : '/wp-admin/admin-ajax.php';

        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.text()) // Expecting HTML fragment
        .then(html => {
            spinner.style.display = "none";
            resultsDiv.innerHTML = html;
        })
        .catch(err => {
            console.error(err);
            spinner.style.display = "none";
            resultsDiv.innerHTML = '<p style="color:white;">Error loading results.</p>';
        });
    }

});